import { render, staticRenderFns } from "./ClassList.vue?vue&type=template&id=4881e8ff&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"
import style0 from "./ClassList.vue?vue&type=style&index=0&id=4881e8ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4881e8ff",
  null
  
)

export default component.exports